<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>

    <!-- <v-card style="border-radius:0!important">
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>Subcategorias de {{category.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                icon
                dark
                @click="$emit('cancel')"
            >
                <v-icon>fa-times</v-icon>
          </v-btn>
          </v-toolbar-items>
        </v-toolbar>
         <v-container style="min-height:90vh" fluid  > -->

    <v-card class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span class="headline">Subcategorias de {{ category.name }}</span>
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <search name="subcategorías" />
            </v-col>

            <v-col style="text-align: end" cols="12" sm="12" md="12">
              <v-btn
                color="btn-color"
                class="mt-3 mr-5"
                @click="showAdd"
                :loading="loading"
              >
                <v-icon left> fas fa-plus </v-icon>
                Agregar subcategoría
              </v-btn>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <files-table
                @menuClick="handleMenuActions($event)"
                :items="subcategories"
                :showList="true"
                :showEdit="true"
                :showDelete="true"
                :loading="loading"
                :headers="headers"
              />
            </v-col>
            <!-- <v-col
              class="pa-5"
              cols="12"
              sm="3"
              md="3"
              v-for="(item, index) of filteredItems"
              :key="index"
            >
              <card
                @menuClick="handleMenuActions($event, item)"
                :name="item.name"
                :image="item.image ? item.image.original : ''"
                :items="menuItems"
              />
            </v-col> -->
          </v-row>
        </v-container>
      </v-card-text>
      <!-- <v-fab-transition class="floating-btn">
            <v-btn
                @click="showAdd"
                color="primary"
                fab
                large
                :loading="loading"
                dark
                bottom
                right
            >
                <v-icon>fas fa-plus</v-icon>
            </v-btn>
        </v-fab-transition> -->
    </v-card>

    <v-dialog
      v-if="addSubcategory"
      persistent
      max-width="70%"
      v-model="addSubcategory"
    >
      <new-subcategory
        :category="category"
        :originalItem="selectedItem"
        @success="added"
        @cancel="addSubcategory = false"
      />
    </v-dialog>

    <v-dialog
      v-if="viewImageDialog"
      persistent
      v-model="viewImageDialog"
      hide-overlay
      fullscreen
      max-width="60%"
    >
      <view-file
        :url="selectedItem.image.original"
        @success="added"
        type="image"
        @cancel="viewImageDialog = false"
      />
    </v-dialog>

    <v-dialog max-width="500px" v-if="deleteDialog" v-model="deleteDialog">
      <delete-item
        ref="deleteComponent"
        :name="selectedItem.name"
        @success="confirmDelete"
        @cancel="deleteDialog = false"
      />
    </v-dialog>

    <v-dialog
      v-if="addProductsDialog"
      persistent
      max-width="100%"
      v-model="addProductsDialog"
    >
      <add-products
        @success="addedSuccess"
        :category="category"
        :subcategory="selectedItem"
        @cancel="addProductsDialog = false"
      />
    </v-dialog>
  </div>
</template> 

<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";
import search from "@/components/search.vue";
import newSubcategory from "./add-subcategories";
import addProducts from "./add-products";
import deleteItem from "@/components/delete";
import filesTable from "@/components/files-table";
import viewFile from "@/components/view-file";

export default {
  components: {
    search,
    newSubcategory,
    addProducts,
    deleteItem,
    filesTable,
    viewFile,
  },
  name: "subcategories",
  props: ["category"],
  data() {
    return {
      snackbarText: "",
      snackbar: false,
      loading: true,
      subcategories: [],
      addSubcategory: false,
      addProductsDialog: false,
      viewImageDialog: false,
      headers: [
        {
          value: "image",
          width: "150px",
        },
        {
          text: "Nombre",
          value: "name",
          width: "150px",
        },
        {
          text: "Descripción",
          value: "description",
          width: "150px",
        },
        {
          text: "Fecha de creación",
          value: "createdAt",
          width: "200px",
        },
        {
          value: "options",
          sortable: false,
          align: "end",
        },
      ],
      // menuItems: [
      //   { title: "Agregar productos", icon: "fas fa-hockey-puck" },
      //   { title: "Editar", icon: "fas fa-edit" },
      //   { title: "Eliminar", icon: "fas fa-trash" },
      // ],
      selectedItem: null,
      deleteDialog: false,
    };
  },
  computed: {
    ...mapState(["user", "userDoc", "groupId"]),
    filteredItems() {
      if (!this.$store.state.search) {
        return this.sortedArray(this.subcategories);
      } else {
        return this.sortedArray(
          this.subcategories.filter((item) =>
            item.name
              .toLowerCase()
              .includes(this.$store.state.search.toLowerCase())
          )
        );
      }
    },
  },

  methods: {
    sortedArray: function (data) {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return data.sort(compare);
    },
    viewImage(item) {
      this.selectedItem = item;
      this.viewImageDialog = true;
    },
    showAdd() {
      this.selectedItem = null;
      this.addSubcategory = true;
    },
    handleMenuActions(payload) {
      switch (payload.action) {
        case 0:
          this.viewImage(payload.item);
          break;
        // case 0:
        //   this.viewProducts(payload.item);
        //   break;
        case 1:
          this.edit(payload.item);
          break;
        case 2:
          this.showDeleteDialog(payload.item);
          break;
        case 3:
          this.viewProducts(payload.item);
          break;
      }
    },
    addedSuccess() {
      this.addProductsDialog = false;
      this.snackbarText = "Productos agregados exitosamente.";
      this.snackbar = true;
    },
    showDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    confirmDelete() {
      this.$refs.deleteComponent.loading = true;
      db.collection("categories")
        .doc(this.category[".key"])
        .collection("subcategories")
        .doc(this.selectedItem[".key"])
        .delete()
        .then((response) => {
          this.snackbarText = "Subcategoría borrada exitosamente.";
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
          this.deleteDialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
        });
    },
    added() {
      this.addSubcategory = false;
      this.snackbarText = `Subcategoría ${
        this.selectedItem ? "editada" : "agregada"
      } exitosamente.`;
      this.snackbar = true;
    },
    edit(item) {
      this.selectedItem = item;
      this.addSubcategory = true;
    },
    viewProducts(item) {
      this.selectedItem = item;
      this.addProductsDialog = true;
    },
  },
  mounted() {
    this.$binding(
      "subcategories",
      db
        .collection("categories")
        .doc(this.category[".key"])
        .collection("subcategories")
    ).then((res) => {
      this.loading = false;
    });
  },
};
</script>
